/**
 * Copyright © 2018 Galaxy Software Services https://github.com/GSS-FED/vital-ui-kit-react
 * MIT license
 */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import styled from 'styled-components';
import cn from 'classnames';
import { tween, styler, easing } from 'popmotion';
import { Badge } from '@vital-ui/react-badge';
import { defaultTheme } from '@vital-ui/react-theme';
import { ListTitleWrapper, ListLi, ListTitle } from './styled';
import SubListItem from './SubListItem';
import { Arrow } from './Arrow';
var Icon = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  pointer-events: none;\n  color: ", ";\n  transform: ", ";\n  transition: transform 0.1s ease-in;\n  transform-origin: center center;\n  width: ", ";\n  height: ", ";\n"], ["\n  pointer-events: none;\n  color: ", ";\n  transform: ",
    ";\n  transition: transform 0.1s ease-in;\n  transform-origin: center center;\n  width: ", ";\n  height: ", ";\n"])), function (_a) {
    var open = _a.open, theme = _a.theme;
    return (open ? "" + theme.info : 'inherit');
}, function (props) {
    return props.open ? "rotateZ(-180deg)" : "rotateZ(0deg)";
}, function (_a) {
    var size = _a.size;
    return size + "px";
}, function (_a) {
    var size = _a.size;
    return size + "px";
});
Icon.defaultProps = {
    theme: defaultTheme,
};
var RightWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])));
var InnerWrapper = styled.ul(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  will-change: height;\n  background-color: ", ";\n  overflow: hidden;\n"], ["\n  will-change: height;\n  background-color: ", ";\n  overflow: hidden;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.list.item.bg;
});
InnerWrapper.defaultProps = {
    theme: defaultTheme,
};
var BadgeWrapper = styled(ListTitle)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  text-align: right;\n  padding-right: ", ";\n"], ["\n  text-align: right;\n  padding-right: ", ";\n"])), function (props) { return (props.hasIconRight ? '20px' : '0'); });
var ListItem = /** @class */ (function (_super) {
    __extends(ListItem, _super);
    function ListItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            open: _this.props.open || false,
        };
        _this.onItemClick = function () {
            if (_this.child) {
                if (!!_this.props.collapse &&
                    !_this.state.open &&
                    _this.props.dispatchClose) {
                    _this.props.dispatchClose(_this.props.level || 0);
                }
                _this.startAnimation();
                if (_this.props.onClick) {
                    _this.props.onClick();
                }
            }
        };
        _this.startAnimation = function () {
            var stylerBall = styler(_this.child);
            // Animation after state change
            if (!_this.state.open) {
                _this.child.style.display = '';
            }
            tween({
                from: { height: _this.state.open ? _this.child.clientHeight : 0 },
                to: { height: _this.state.open ? 0 : _this.child.clientHeight },
                duration: 200,
                ease: _this.state.open ? easing.easeIn : easing.easeOut,
            }).start({
                update: stylerBall.set,
                complete: function () {
                    _this.setState(function (prevState) { return ({
                        open: !prevState.open,
                    }); }, function () {
                        setTimeout(function () {
                            if (!_this.state.open) {
                                _this.child.style.display = 'none';
                            }
                            _this.child.style.height = '';
                        }, 50);
                    });
                },
            });
        };
        _this.iconHandler = function () {
            return _this.props.children ? 'chevron-down' : 'chevron-right';
        };
        _this.renderBadge = function () {
            if (typeof _this.props.badge === 'string' ||
                typeof _this.props.badge === 'number') {
                return (React.createElement(BadgeWrapper, { hasIconRight: _this.props.children || _this.props.hasLink },
                    React.createElement(Badge, null, _this.props.badge)));
            }
            return _this.props.badge;
        };
        return _this;
    }
    ListItem.prototype.componentDidMount = function () {
        if (this.child) {
            this.child.style.display = this.state.open ? '' : 'none';
        }
    };
    ListItem.prototype.render = function () {
        var _this = this;
        var _a = this.props, title = _a.title, children = _a.children, hasLink = _a.hasLink, level = _a.level, themed = _a.themed, badge = _a.badge, border = _a.border, style = _a.style, className = _a.className;
        return (React.createElement(ListLi, { style: style, className: cn('vital__ListItem', className) },
            React.createElement(ListTitleWrapper, { className: "vital__ListItem-wrapper", hasChildren: !!children, hasLink: hasLink, onClick: this.onItemClick, level: level, border: border, themed: themed },
                React.createElement(ListTitle, { className: "vital__ListItem-title" }, title),
                React.createElement(RightWrapper, null,
                    badge && this.renderBadge(),
                    (children || hasLink) && (React.createElement(Icon, { open: this.state.open, size: this.props.iconSize },
                        React.createElement(Arrow, null))))),
            children && (React.createElement(InnerWrapper, { ref: function (s) {
                    _this.child = s;
                } },
                React.createElement(SubListItem, { isChildren: !!children, level: level + 1, themed: themed }, children)))));
    };
    ListItem.defaultProps = {
        children: null,
        level: 0,
        isChildren: false,
        open: false,
        badge: null,
        onClick: null,
        style: undefined,
        iconSize: 16,
        className: '',
    };
    return ListItem;
}(React.Component));
export default ListItem;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=ListItem.js.map